// Official DIG logo (three-card fan + wordmark). Transparent PNG works on light & dark.
export function DigLogo({ dark = false, size = 68, showText = true }) {
  return (
    <img
      src="/dig/DIG-Logo-Horizontal.png"
      alt="Destination Innovation Game"
      style={{ height: size, width: "auto" }}
      className="select-none"
      data-testid="dig-logo"
    />
  );
}

// Compact mark-only fan (for tight spaces / favicons).
export function DigMark({ size = 40 }) {
  return <img src="/dig/DIG-Mark-Small.svg" alt="DIG" style={{ height: size }} className="select-none" />;
}
